/* eslint-disable react-refresh/only-export-components -- standard context pattern: provider, hook, and context co-located */
import { createContext, type ReactNode, useContext } from 'react';

interface UnsavedChangesContextValue {
  hasUnsavedChanges: boolean;
  guard: (action: () => void) => boolean;
  /** Save pending changes. Resolves when save completes. */
  onSave?: () => Promise<void>;
}

export const UnsavedChangesContext =
  createContext<UnsavedChangesContextValue | null>(null);

export function useUnsavedChanges(): UnsavedChangesContextValue | null {
  return useContext(UnsavedChangesContext);
}

interface UnsavedChangesProviderProps {
  children: ReactNode;
  value: UnsavedChangesContextValue;
}

export function UnsavedChangesProvider({
  children,
  value,
}: UnsavedChangesProviderProps) {
  return (
    <UnsavedChangesContext.Provider value={value}>
      {children}
    </UnsavedChangesContext.Provider>
  );
}
